class Map {
    constructor($el) {
        this.$el = $el;
        this.$pin = $el.find('[data-map="pin"]');
        this.$description = $el.find('[data-map="description"]');
        this.init();
    }

    init = () => {

        this.$pin.first().addClass('active');
        this.$description.first().show();
        console.log("Map iniited");



        this.$pin.on('click', this.clickHandler);
    }

    clickHandler = (event) => {
        const clickedPinId = $(event.currentTarget).data('id');
        console.log("Pin clicked");
        this.$description.hide();  
        this.$pin.removeClass('active');  
        
        this.$description.each((index, el) => {
            const $el = $(el);
            if ($el.data('id') === clickedPinId) {
                $el.show();  
            }
        });

        $(event.currentTarget).addClass('active');  
    }
}

export default Map;
